// extracted by mini-css-extract-plugin
export default {"cls1":"Popover-cls1___8d4a44270197f08dd3f","cls2":"Popover-cls2___761f255b9109eb1906b Popover-cls1___8d4a44270197f08dd3f","inline":"Popover-inline___3465415a4ce588d0c16"};